import React, { useState } from "react";
import { Button } from "reactstrap";

import { ModalHub } from "../_documentosFrete/comum";
import NotaFiscalDetailModal from "../ConsultaNotasFiscais/NotaFiscalDetailModal";
import DetalhePedido from "./DetalhePedido";
import NotasDoPedido from "./NotasDoPedido";
import "../_documentosFrete/styles.css";
import "./styles.css";

// Detalhe do pedido em modal (PO1-3500): o que a linha aberta da tela de
// Pedidos mostra — as NFs do pedido, os dados operacionais e o histórico —
// sem sair da tela de onde foi aberto (quadro do despacho na Torre e no Meu
// Painel). A NF abre o detalhe da NF-e em outro modal.
//
// paramsRecorte: o mesmo recorte de /trackfy/pedidos/notas (de, ate,
// transportadoras) que a tela de Pedidos manda.
export default function PedidoDetalheModal({ pedido, paramsRecorte, embarcadorId, transportadoraId, onClose }) {
  const [notaAberta, setNotaAberta] = useState(null);

  return (
    <ModalHub titulo={`Pedido ${pedido}`} icone="tim-icons icon-bag-16" onClose={onClose} maxWidth={1100}>
      <section className="pedidos__bloco">
        <h5 className="pedidos__bloco-titulo">Notas fiscais</h5>
        <NotasDoPedido pedido={pedido} paramsRecorte={paramsRecorte} onAbrirNota={setNotaAberta} />
      </section>
      <DetalhePedido pedido={pedido} versao={0} />
      <div className="docs-frete__modal-rodape">
        <Button color="secondary" size="sm" onClick={onClose}>
          Fechar
        </Button>
      </div>
      <NotaFiscalDetailModal
        isOpen={Boolean(notaAberta)}
        notaFiscalId={notaAberta}
        embarcadorId={embarcadorId}
        transportadoraId={transportadoraId}
        onClose={() => setNotaAberta(null)}
      />
    </ModalHub>
  );
}
